import {DateTime} from 'luxon';
import {endOfMonth, endOfWeek, startOfWeek} from '@/utlitities/helper';

export class Calendar{
    public Months: CalendarMonth[] = [];
}

export class CalendarMonth{
    public WeekDayStrings: string[] = [];
    public Month!: number;
    public Year!: number;
    public MonthString!: string;
    public Days: CalendarDay[] = [];
}

export class CalendarDay{
    public Day!: DateTime;
    public IsDifferentMonth!: boolean;
}

export function getCalendarForYear(year: number) {
    let result = new Calendar();

    for (let month = 1; month <= 12; month++){
        let monthItem = new CalendarMonth();

        let firstOfMonth = DateTime.fromFormat('1.' + month + '.' + year, 'd.M.yyyy', {zone: 'utc'});
        let lastOfMonth = endOfMonth(firstOfMonth);

        for (let day = firstOfMonth; day <= lastOfMonth; day = day.plus({days: 1})){
            let dayItem = new CalendarDay();
            dayItem.Day = day;
            dayItem.IsDifferentMonth = parseInt(day.toFormat('M')) !== month;

            monthItem.Days.push(dayItem);
        }

        monthItem.Month = month;
        monthItem.MonthString = firstOfMonth.toFormat('MMMM');
        monthItem.Year = year;
        for (let weekDayDate = startOfWeek(firstOfMonth); weekDayDate <= endOfWeek(firstOfMonth); weekDayDate = weekDayDate.plus({days : 1})){
            monthItem.WeekDayStrings.push(weekDayDate.toFormat('EEE'));
        }

        result.Months.push(monthItem);
    }

    return result;
}

